export default __webpack_public_path__ + "3b0fdd2e49c5c77915e0f26e1cb843be.png";